import { ROLE_LABELS } from '@sime/shared';

/**
 * Derived role options for select dropdowns.
 * Used by user-form and users-list pages.
 */
export const ROLE_OPTIONS: { value: number; label: string }[] = Object.entries(ROLE_LABELS).map(
  ([value, label]) => ({ value: Number(value), label }),
);
